export type InitiateResponse = {
    encryptedPlayPayload: string;
    fileName: string;
    hasEnglishSubtitles: boolean;
    hasOriginalSubtitles: boolean;
    hasPreview: boolean;
    mimeType: string;
    isEdited: boolean;
    isTranscoded: boolean;
    duration: number;
    hasMetadata: boolean;
};

export const apiUrl = import.meta.env.VITE_API_URL;

export const getParameters = () => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    console.log([...params.entries()]);
    const watermark = params.get("watermark");
    const decoded = watermark
        ? decodeURIComponent(decodeURIComponent(watermark))
        : watermark;

    const payload = params.get("payload");
    const signature = params.get("signature");

    return {
        payload,
        signature,
        inTc: params.get("inTc"),
        outTc: params.get("outTc"),
        watermark: decoded?.split(/\r?\n/),
        hideControls: params.get("hideControls") === "true",
    };
};

export const pad = (number: number) => number.toString().padStart(2, "0");

export const formatTime = (time: number) => {
    const totalMilliseconds = Math.round(time * 1000);
    const hours = Math.floor(totalMilliseconds / (3600 * 1000));
    const minutes = Math.floor(
        (totalMilliseconds % (3600 * 1000)) / (60 * 1000)
    );
    const seconds = Math.floor((totalMilliseconds % (60 * 1000)) / 1000);
    const frames = Math.floor((totalMilliseconds % 1000) / (1000 / 25));

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}:${pad(frames)}`;
};

export const parseFormattedTime = (formattedTime: string) => {
    const parts = formattedTime.split(":");

    if (parts.length !== 4) {
        throw new Error("Invalid format. Expected format: hh:mm:ss:zz");
    }

    const [hours, minutes, seconds, frames] = parts.map(Number);

    if ([hours, minutes, seconds, frames].some(isNaN)) {
        throw new Error("Invalid number in time format.");
    }

    return hours * 3600 + minutes * 60 + seconds + frames / 25;
};

const prettyPrintObject = <T>(obj: T, indent = 0): string => {
    if (typeof obj !== "object" || obj === null) {
        return `<span class="error-value">${obj}</span>`;
    }

    const entries = Object.entries(obj)
        .map(([key, value]) => {
            const valueHtml =
                typeof value === "object" && value !== null
                    ? prettyPrintObject(value, indent + 1)
                    : `<span class="error-value">${value}</span>`;
            return `<div class="error-entry" style="padding-left: ${
                indent * 10
            }px">
                        <strong class="error-key">${key}:</strong> ${valueHtml}
                    </div>`;
        })
        .join("");
    return `<div>${entries}</div>`;
};

export const spawnErrorOverlay = (message: string) => {
    let overlay = document.getElementById("error-overlay");

    if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = "error-overlay";
        document.body.appendChild(overlay);
    }

    let content: string;
    try {
        const parsed = JSON.parse(message);
        content = prettyPrintObject(parsed);
    } catch {
        content = `<div class="error-text">${message}</div>`;
    }

    const errorContainer = document.createElement("div");
    errorContainer.classList.add("error-container");
    errorContainer.innerHTML = content;

    overlay.appendChild(errorContainer);
};
